import { supabase } from '@/lib/supabase.js';
import { Roles } from '@/constants/roles';
/**
 * ユーザーの登録（emailとパスワード方式）
 * @param {object} form
 * @returns {object} userオブジェクト
 */
export async function signUpWithEmail(form) {
  const { data, error } = await supabase.auth.signUp({
    email: form.email,
    password: form.password,
    options: {
      // ここが重要！SQLトリガーがここを見に行きます
      data: {
        username: form.username || form.email,
        role_id: Roles.USER.id,
      },
    },
  });
  if (error) {
    console.error('サインアップ失敗', error.message);
    throw error;
  }
  return data;
}

/**
 * ログイン(emailとパスワード方式)
 * @param {string} email
 * @param {string} password
 * @returns {object}
 */
export async function signInWithEmail(form) {
  const { data, error } = await supabase.auth.signInWithPassword({
    email: form.email,
    password: form.password,
  });
  if (error) {
    console.error('サインイン失敗', error.message);
    throw error;
  }
  return data.user;
}

/**
 * googleで認証する
 */
export async function loginWithGoogle() {
  try {
    await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        scopes: 'https://www.googleapis.com/auth/calendar',
        queryParams: {
          prompt: 'consent',
          access_type: 'offline',
        },
        redirectTo: window.location.origin + '/',
      },
    });
  } catch (error) {
    console.error('Googleログイン失敗', error.message);
  }
}
